import { render, staticRenderFns } from "./TypographyBannerSection.vue?vue&type=template&id=48e5a059"
import script from "./TypographyBannerSection.vue?vue&type=script&lang=ts"
export * from "./TypographyBannerSection.vue?vue&type=script&lang=ts"
import style0 from "./TypographyBannerSection.vue?vue&type=style&index=0&id=48e5a059&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports